export default __webpack_public_path__ + "static/media/maintenance.3e0cd74b.png";